import React from 'react';

type ArrowIconProps = {
  color?: string;
};

export const SliderRightArrow: React.FC<ArrowIconProps> = ({
  color = '#2E2E2E',
}) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M13 4L21 12L13 20" stroke={color} strokeWidth="2" />
    <path d="M4 12L21 12" stroke={color} strokeWidth="2" />
  </svg>
);
